import React from 'react';
import { LoginForm } from '../components/Auth/LoginForm';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BackgroundCanvas } from '../components/BackgroundCanvas';

export const LoginPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="auth-page">
      <BackgroundCanvas opacity={0.3} />

      <div className="term-panel">
        <div className="term-panel__bar">
          <span className="term-panel__bar-dot" />
          <span className="term-panel__bar-dot" />
          <span className="term-panel__bar-dot" />
          <span className="term-panel__bar-title">{t('auth.termTitleAuth')}</span>
        </div>
        <div className="term-panel__body">
          <LoginForm />
          <div className="auth-form__footer">
            {t('auth.noAccount')}
            <Link to="/register">{t('auth.createOne')}</Link>
            &nbsp;·&nbsp;
            <Link to="/">{t('auth.backToMap')}</Link>
          </div>
          <p style={{ fontSize: '0.62rem', opacity: 0.55, marginTop: '0.75rem', textAlign: 'center' }}>
            {t('common.ofertaNotice')}{' '}
            <Link to="/about?tab=oferta" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--px-accent)', textDecoration: 'underline' }}>
              {t('common.ofertaLink')}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};
